import axios from "axios";
import { Auth_Proto,Auth_Domain,Auth_Port } from "../Component/consts";


class PaymnetServices {

    CreatePlan(data) {
       return axios.post(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/subscriptions/creatplan`,data)
    }
    CreateSubscription(data){
        return axios.post(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/subscriptions/createsubscription`,data)
    }
    VerifyPayment(data){
        return axios.post(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/payments/verify-payment`,data)
    }

    VerifySubscriprionPayment(data){
        return axios.post(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters/payments/verify-subscription-payment`,data)
    }
}

export default new PaymnetServices();
